const DEFAULT_TIMEOUT = 120000;

export function runHandlerWithTimeout<T>(
  handler: () => Promise<T>,
  timeout = DEFAULT_TIMEOUT
): Promise<T> {
  return Promise.race<T>([
    handler(),
    new Promise((_, reject) =>
      setTimeout(
        () =>
          reject(
            new Error('Request Timeout: The logs could not be retrieved.')
          ),
        timeout
      )
    ),
  ]);
}
